import { List } from 'antd';
import styled from 'styled-components';

export default styled(List)`
	// Add your styles here
`;
